// extracted by css-extract-rspack-plugin
export default {"rowBox":"rowBox-ZmKB0D","colBox":"colBox-sPmywW","titleBox":"titleBox-UPFdGf","content":"content-Gu9DL8"};